/**
 * @format
 */
import {
  UPDATE_LIST_SUCCESS,
  UPDATE_LIST_FAILURE,
  UPDATE_LIST_OPTIMISTIC,
} from '../actions';
import { enqueueNotification } from '../../app';
import request from '../../../helpers/request';

export default (formData, list_id, workspace_id) => {
  return async (dispatch, getState) => {
    const state = getState();
    const prevList = state.deal.lists?.[workspace_id]?.[list_id] || {};

    // Optimistic update
    dispatch({
      type: UPDATE_LIST_OPTIMISTIC,
      payload: { workspace_id, list_id, formData },
    });

    try {
      const { data } = await request.put(
        `/api/pipeline/lists/v1/${workspace_id}/${list_id}`,
        formData,
        dispatch
      );
      if (data.success) {
        dispatch({
          type: UPDATE_LIST_SUCCESS,
          payload: {
            list: data.data,
            workspace_id,
          },
        });
        return Promise.resolve(data);
      } else {
        const message = data.message;
        dispatch({
          type: UPDATE_LIST_FAILURE,
          payload: { message, listId: list_id, prevList, workspace_id },
        });
        dispatch(enqueueNotification(message));
        return Promise.reject(new Error(message));
      }
    } catch (err) {
      const message =
        'Something went wrong while updating list, please try again.';
      dispatch({
        type: UPDATE_LIST_FAILURE,
        payload: { message, listId: list_id, prevList, workspace_id },
      });
      dispatch(enqueueNotification(message));
      return Promise.reject(err);
    }
  };
};
